module.exports = require('./lib');


// WEBPACK FOOTER //
// ./~/react-autosize-textarea/index.js